module.exports = __webpack_public_path__ + "static/media/apple.3c5affab.svg";